document.addEventListener("DOMContentLoaded", function () {
    const sliders = document.querySelectorAll(".collection-header-slider");
    let swiperInstances = [];

    function checkAndToggleSwiper() {
        sliders.forEach((container, index) => {
            const wrapper = container.querySelector(".swiper-wrapper");
            if (!wrapper) return;

            const sliderIndex = container.getAttribute("data-slider-index");
            const prevBtn = document.querySelector(`.swiper-button-prev[data-slider-index="${sliderIndex}"]`);
            const nextBtn = document.querySelector(`.swiper-button-next[data-slider-index="${sliderIndex}"]`);

            const contentWidth = wrapper.scrollWidth;
            const containerWidth = container.clientWidth;
            const shouldEnableSwiper = contentWidth > containerWidth;

            let swiperInstance = swiperInstances[index];

            if (shouldEnableSwiper && !swiperInstance) {
                if (typeof Swiper !== 'undefined') {
                    swiperInstance = new Swiper(container, {
                        slidesPerView: "auto",
                        navigation: {
                            nextEl: nextBtn,
                            prevEl: prevBtn,
                        },
                    });

                    swiperInstances[index] = swiperInstance;

                    if (prevBtn) prevBtn.style.display = "flex";
                    if (nextBtn) nextBtn.style.display = "flex";
                }
            } else if (!shouldEnableSwiper && swiperInstance) {
                swiperInstance.destroy(true, true);
                swiperInstances[index] = null;

                wrapper.removeAttribute("style");
                if (prevBtn) prevBtn.style.display = "none";
                if (nextBtn) nextBtn.style.display = "none";
            }
        });
    }

    window.addEventListener("resize", checkAndToggleSwiper);
    window.addEventListener("load", checkAndToggleSwiper);
    checkAndToggleSwiper(); // Initial check
});
